
export function getLevelFromRate(prate: number): number {
    return Math.floor(prate / 100);
}
export function getPercentFromRate(prate: number): number {
    var level: number = getLevelFromRate(prate);
    var nextLevel = level + 1;
    return Math.round(((prate - (level * 100)) / ((nextLevel * 100) - (level * 100))) * 100);
}